import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import useMediaQuery from '@/hooks/use-media-query'
import { breakpoints } from '@/styles'
import { UnverifiedIcon } from '@/components/icons'
import { colors } from '@/styles'

const UnverifiedContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${colors.yellow96};
  color: ${colors.yellow24};
  border-radius: 8px;
  font-size: 10px;
  width: ${({ width }) => width || '100%'};
  height: ${({ height }) => height || '100%'};
  flex-shrink: 0;
  padding-top: ${({ top }) => top || 4}px;
  padding-right: ${({ right }) => right || 8}px;
  padding-bottom: ${({ bottom }) => bottom || 4}px;
  padding-left: ${({ left }) => left || 8}px;
`

const StyledUnverifiedIcon = styled(UnverifiedIcon)`
  margin-right: 3px;
`

const UnverifiedBadge = ({
  width,
  height,
  top,
  bottom,
  right,
  left,
  showSmallOnMobile = false
}) => {
  const isMobile = useMediaQuery(`(max-width: ${breakpoints.ipadMiniMax})`)
  const { t } = useTranslation()

  return (
    <UnverifiedContainer
      width={width}
      height={height}
      top={top}
      bottom={bottom}
      right={right}
      left={left}
    >
      <StyledUnverifiedIcon />
      {showSmallOnMobile
        ? !isMobile && t('b.component.view.unverified.text', 'Unverified')
        : t('b.component.view.unverified.text', 'Unverified')}
    </UnverifiedContainer>
  )
}

export default UnverifiedBadge
